import { useCallback, useEffect, useState, useSyncExternalStore } from 'react';
import { createModeSwitch } from './engine-kit/mode-switch';
import type { StudioApp } from './studio-api';

/** Общий переход Фото/Видео: один запрос, черновики по владельцу/приложению, проверка владельца до и после GET.
    Ядро — engine-kit/mode-switch.ts (его же держит кадр движка с режимами, mode-group.tsx). */
export function useStudioMediaMode(initialApp: StudioApp, initialInputs: Record<string, unknown> | undefined, screen: 'photo' | 'video') {
  const [core] = useState(() => createModeSwitch(initialApp, initialInputs, screen));
  const { active, seed, switching, error } = useSyncExternalStore(core.subscribe, core.get);
  useEffect(() => core.attach(), [core]);
  const switchMode = useCallback(
    async (id: number, inputs: Record<string, string>, expectedOwner?: number, transfer = false) => {
      await core.switchMode(id, inputs, expectedOwner, transfer);
    },
    [core],
  );
  return { active, seed, switching, error, switchMode };
}
